import NProgress from "nprogress"; // progress bar
import router from "./index";
import store from "../store";
import authRouter from "./modules/auth";
import "nprogress/nprogress.css"; // progress bar style

NProgress.configure({ showSpinner: false }); // NProgress Configuration

/**
 * Generate white list
 */
const whiteList = []
  .concat(Array.from(authRouter, (route) => route.path))
  .concat(Array.from(authRouter, (route) => route.alias))
  .filter((route) => route);

const hasPermission = (roles, route) => {
  if (route.meta && route.meta.roles) {
    return route.meta.roles.includes(roles);
  }
  return true;
};

router.beforeEach(async (to, from, next) => {
  console.log(window.location.host);
  // redirecting to new domain if domain is birchequipment.incus5.com
  if (
    window.location.host == "birchequipment.incus5.com" ||
    window.location.host == "sms.birchequipment.com"
  ) {
    window.location.href = "https://maxx.birchequipment.com/";
  }
  NProgress.start();
  try {
    if (store.getters.token) {
      if (whiteList.includes(to.path)) {
        next({ path: "/" });
      } else {
        // if (!store.getters.roles || !store.getters.user) {
        if (!store.getters.token) {
          await store.dispatch("LogOut");
          next({ path: "/signin" });
        } else {
          if (!hasPermission(store.getters.roles, to)) {
            next({ path: "/" });
          } else {
            if (to.params.key) {
              to.meta.title = to.params.key;
            }
            // next();
            if (
              store.getters.firstTimeLogin &&
              to.fullPath != "/first-time-change-password"
            ) {
              //If user is first time trying to change password and trying to access other secured pages is not allowed
              next({ path: "/first-time-change-password" });
            } else if (
              store.getters.twoFactorEnabled &&
              !store.getters.firstTimeLogin &&
              to.fullPath != "/two-factor-authenticate"
            ) {
              //If user is on two factor authentication page and trying to access other secured pages is not allowed and logged out
              next({ path: "/two-factor-authenticate" });
            } else if (
              !store.getters.firstTimeLogin &&
              to.fullPath == "/first-time-change-password"
            ) {
              console.log("11111");
              //if user is authenticated and firstTimeLogin flag is false and trying to access the firsttimechangepassword page
              next({ path: "/" });
            } else if (
              !store.getters.twoFactorEnabled &&
              to.fullPath == "/two-factor-authenticate"
            ) {
              //if user is authenticated and firstTimeLogin flag is false and trying to access the multifactorauthenticate page
              next({ path: "/" });
            } else {
              next();
            }
          }
        }
      }
    } else {
      if (whiteList.includes(to.path)) {
        next();
      } else {
        console.log(to.path);
        next(`/signin?redirect=${to.path}`);
      }
    }
  } catch (err) {
    console.warn(`[router.beforeEach]\t${to.path}: ${err}`);
  }
  NProgress.done();
});

router.afterEach(async () => {
  NProgress.done();
});
